<div *ngIf="!isNewRecurringProfile" id="ach-confirmation" data-testid="new-ach-transfer-confirmation">
    <div id="success-icon" data-testid="success-icon" class="success-icon"></div>
    <div class="confirmation-text">{{newAchTransferText}}</div>
</div>
<div *ngIf="newProfileText" id="ach-confirmation" data-testid="new-profile-confirmation">
    <div id="success-icon" data-testid="success-icon" class="success-icon"></div>
    <div class="confirmation-text">{{newProfileText}}</div>
</div>